<template>
  <div class="customer-editor">

      <el-form :model="form" :rules="rules" ref="form" :label-width="width" v-loading="loading">

        <el-row :gutter="0">

          <el-col :span="11">

<!--            <el-form-item label="家庭档案编号" prop="sn">-->
<!--              <el-input v-model="form.sn" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->

            <el-form-item label="家庭总人口">
              <el-input v-model="form.member_total" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="现住人口">
              <el-input v-model="form.live_total" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="家庭电话">
              <el-input v-model="form.tel" autocomplete="off"></el-input>
            </el-form-item>

<!--            <el-form-item label="居住面积">-->
<!--              <el-input v-model="form.area" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="饮用水来源">-->
<!--              <el-input v-model="form.water_source" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="家庭经济状况	">-->
<!--              <el-input v-model="form.economy" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="卫生设施类型	">-->
<!--              <el-input v-model="form.equipment_type" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->



          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="11">

            <el-form-item label="月人均收入	" :label-width="width">
              <el-input v-model="form.monthly_income" autocomplete="off"></el-input>
            </el-form-item>

<!--            <el-form-item label="住房类型">-->
<!--              <el-input v-model="form.house_type" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="燃料类型">-->
<!--              <el-input v-model="form.fuel_type" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->

            <el-form-item label="动物种类">
              <el-input v-model="form.animal_type" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="动物数量">
              <el-input v-model="form.animal_number" autocomplete="off"></el-input>
            </el-form-item>

<!--            <el-form-item label="动物种类">-->
<!--              <el-input v-model="form.animal_type2" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="动物数量">-->
<!--              <el-input v-model="form.animal_number2" autocomplete="off"></el-input>-->
<!--            </el-form-item>-->


          </el-col>

        </el-row>

        <el-divider></el-divider>

        <el-row :gutter="0">
          <el-col :span="24">
            <div class="member-title">家庭成员列表<el-button type="primary" size="mini" icon="el-icon-plus" @click="editMember()" class="add-member">添加成员</el-button></div>

            <el-table :data="memberList" border style="width: 100%;margin-bottom: 20px;">
              <el-table-column prop="relation" label="与户主关系" align="center">
                <template slot-scope="scope">{{getRelationText(scope.row.relation)}}</template>
              </el-table-column>
              <el-table-column prop="name" label="姓名" align="center"></el-table-column>
              <el-table-column prop="birthday" label="出生日期" align="center">
                <template slot-scope="scope">{{timeFormat(scope.row.birthday)}}</template>
              </el-table-column>
              <el-table-column prop="company" label="工作单位及职责" align="center">
                <template slot-scope="scope">{{scope.row.company}}{{scope.row.job ? '(' + getJobText(scope.row.job) + ')' : ''}}</template>
              </el-table-column>
              <el-table-column prop="city" label="定居城市" align="center"></el-table-column>
              <el-table-column prop="live_address" label="居住地址" align="center"></el-table-column>
              <el-table-column prop="phone_number" label="手机/联系电话" align="center"></el-table-column>
              <el-table-column prop="over_60" label="是否大于60周岁" align="center">
                <template slot-scope="scope">{{getIsOverText(scope.row.birthday)}}</template>
              </el-table-column>
              <el-table-column prop="is_owner" label="共有产权人" width="90" align="center">
                <template slot-scope="scope">{{getIsOwnerText(scope.row.is_owner)}}</template>
              </el-table-column>
              <el-table-column prop="operation" label="操作">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" icon="el-icon-edit" v-if="scope.row.id > 0" @click="editMember(scope.row)"></el-button>
                  <el-button type="danger" size="mini" icon="el-icon-delete" v-if="scope.row.id > 0" @click="deleteFamilyMember(scope.row.id)"></el-button>
                </template>
              </el-table-column>
            </el-table>

          </el-col>
        </el-row>


      </el-form>

      <el-dialog title="添加家庭成员" :visible.sync="addVisable" append-to-body :close-on-click-modal="false" top="5vh" width="1200px">
        <el-form :model="memberForm" :rules="memberRules" ref="memberForm" :label-width="width">
          <el-row :gutter="20">
            <el-col :span="11">

              <el-form-item label="姓名" prop="name">
                <el-input v-model="memberForm.name" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="所属组织" prop="organization">
                <el-input v-model="memberForm.organization" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="性别" prop="sex">
                <el-radio v-model="memberForm.sex" label="1">男</el-radio>
                <el-radio v-model="memberForm.sex" label="2">女</el-radio>
              </el-form-item>

              <el-form-item label="手机" prop="phone_number">
                <el-input v-model="memberForm.phone_number" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="家庭电话" prop="family_tel">
                <el-input v-model="memberForm.family_tel" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="办公电话" prop="office_tel">
                <el-input v-model="memberForm.office_tel" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="定居城市" prop="city">
                <el-input v-model="memberForm.city" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="共有产权人" prop="is_owner">
                  <el-checkbox v-model="memberForm.is_owner">是</el-checkbox>
              </el-form-item>

            </el-col>
            <el-col :span="11">

              <el-form-item label="与户主关系" prop="relation">
                <el-select v-model="memberForm.relation" placeholder="请选择">
                  <el-option v-for="item in relationList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="出生日期" prop="birthday">
                <el-date-picker v-model="memberForm.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>

              <el-form-item label="工作单位" prop="company">
                <el-input v-model="memberForm.company" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="单位地址" prop="company_address">
                <el-input v-model="memberForm.company_address" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="职务" prop="job">
                <el-select v-model="memberForm.job" placeholder="请选择">
                  <el-option v-for="item in jobList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="联系地址" prop="contact_address">
                <el-input v-model="memberForm.contact_address" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item label="居住地址" prop="live_address">
                <el-input v-model="memberForm.live_address" autocomplete="off"></el-input>
              </el-form-item>

            </el-col>
          </el-row>
        </el-form>

        <div class="editor-footer">
          <el-button @click="addVisable = false">取 消</el-button>
          <el-button type="primary" @click="submitMemberForm('memberForm')">保 存</el-button>
        </div>

      </el-dialog>

      <div class="editor-footer">
        <el-button @click="visable = false">取 消</el-button>
        <el-button type="primary" v-if="is_edit" @click="submitForm('form')">保 存</el-button>
      </div>

  </div>
</template>

<script>

  import Common from './common.js'

  export default {
    name: "family-document-editor",
    emits: ['input'],
    props: {
      value: {
        type: Boolean,
        default() {
          return false
        }
      },
      id: {
        type: [Number, String],
        default() {
          return 0
        }
      },
      cclass: {
        type: [Number, String],
        default() {
          return 0
        }
      },
      width: {
        type: String,
        default() {
          return '130px'
        }
      },
      is_edit:{
        type: Boolean,
        default() {
          return true
        }
      }
    },
    data(){
      return{
        visable: this.value,
        addVisable: false,
        loading: false,
        form: this.getFormData({}),
        old_form: this.getFormData({}),
        memberForm: this.getMemberFormData({}),
        memberList: [],
        baseInfo: {},
        rules: {
          sn: [
            { required: true, message: '请输入家庭档案编号', trigger: 'blur' },
          ],
        },
        memberRules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' },
          ],
          relation: [
            { required: true, message: '请选择关系', trigger: 'change' },
          ],
          sex: [
            { required: true, message: '请选择性别', trigger: 'change' }
          ],
        },
        relationList: [{"value":"1","label":"夫妻"},{"value":2,"label":"父子"},{"value":3,"label":"父女"},{"value":4,"label":"母子"},{"value":5,"label":"母女"},{"value":6,"label":"其他"},{"value":7,"label":"亲戚朋友"},{"value":8,"label":"租户"},{"value":9,"label":"叔叔侄子"},{"value":10,"label":"侄子叔叔"}],
        jobList: [{"value":"11","label":"董事长"},{"value":"12","label":"董事"},{"value":"4","label":"执行总经理"},{"value":"14","label":"副总经理"},{"value":"15","label":"总监"},{"value":"5","label":"部门经理"},{"value":"17","label":"主管"},{"value":"6","label":"一般员工"},{"value":"1","label":"厅局级以上"},{"value":"2","label":"处级干部"},{"value":"3","label":"科级干部"},{"value":"22","label":"科员"},{"value":"7","label":"其他"}],
        uploadUrl: Common.getBaseUrl() + 'admin/Customer/uploadFile?login_name=' + window.localStorage.getItem('login') + '&token=' + window.localStorage.getItem('token'),
        uploadData: {},
      }
    },
    mounted() {
      console.log('family document mounted')
      this.getData()
      this.getBaseInfo(res => {
        this.getMemberList()
      })
    },
    watch: {
      value(val) {
      	this.visable = val
      },
      visable(val) {
        this.$emit('input', val)
      },
      id(val) {
        if(this.visable) {
          this.getData()
        }
      }
    },
    methods: {
      getFormData(data) {

        let object = {
          id: 0,
          sn: '',
          member_total: '',
          live_total: '',
          area: '',
          water_source: '',
          economy: '',
          equipment_type: '',
          tel: '',
          monthly_income: '',
          house_type: '',
          fuel_type: '',
          animal_type: '',
          animal_number: '',
          animal_type2: '',
          animal_number2: '',
        }

        let newData = Object.assign({}, object, data)

        if(data.id) {

          for(let k in newData) {
            if(newData[k] === null) newData[k] = ''
          }

        }

        return newData

      },

      getMemberFormData(data) {

        let object = {
          id: 0,
          name: '',
          organization: '',
          sex: '',
          phone_number: '',
          family_tel: '',
          office_tel: '',
          city: '',
          is_owner: '',
          relation: '',
          birthday: '',
          company: '',
          company_address: '',
          job: '',
          contact_address: '',
          live_address: '',
        }

        let newData = Object.assign({}, object, data)

        if(data.id) {
          newData.sex += ''
          newData.is_owner = newData.is_owner == 1
          newData.birthday = newData.birthday === 0 ? '' : Common.timeFormat(newData.birthday, false)
        }

        return newData
      },

      getData() {

        if(this.id > 0) {
          this.loading = true
          this.$myhttp.get('admin/Customer/getFamilyDocumentInfo?customer_id='+this.id).then(backdata => {
            let res = backdata.data
            if(res.code == 200) {
              this.form = this.getFormData(res.data || {customer_id: this.id})
              this.old_form = this.getFormData(res.data || {customer_id: this.id})
            } else {
              this.$message.error('获取客户信息出错！');
            }
            this.loading = false
          })
        } else {
          this.form = this.getFormData({})
          this.old_form = this.getFormData({})
        }

      },
      getBaseInfo(callback) {

        let url = this.cclass == 1 ? 'admin/Customer/getPersonalBasicInfo?customer_id='+this.id : 'admin/Customer/getEnterpriseBasicInfo?customer_id='+this.id

        this.$myhttp.get(url).then(backdata => {
          let res = backdata.data
          if(res.code == 200) {
            this.baseInfo = res.data
            callback()
          } else {
            this.$message.error('获取客户信息出错！');
          }
        })

      },
      mergeMemberList() {
        if(this.baseInfo == null) return false
        this.memberList.unshift({
          id: 0,
          name: this.baseInfo.name ? this.baseInfo.name : '',
          organization: this.baseInfo.organization ? this.baseInfo.organization : '',
          sex: this.baseInfo.sex ? this.baseInfo.sex : '',
          phone_number: this.baseInfo.contact_number ? this.baseInfo.contact_number : '',
          family_tel: '',
          office_tel: '',
          city: '',
          is_owner: '',
          relation: 0,
          birthday: this.baseInfo.birthday ? this.baseInfo.birthday : '',
          company: '',
          company_address: '',
          job: '',
          contact_address: '',
          live_address: '',
        })
      },
      getMemberList() {

        if(this.id > 0) {
          this.$myhttp.get('admin/Customer/getFamilyMemberList?customer_id='+this.id).then(backdata => {
            let res = backdata.data
            if(res.code == 200) {
              this.memberList = res.data || [],
              this.mergeMemberList()
            } else {
              this.$message.error('获取客户信息出错！');
            }
          })
        } else {
          this.$message.error('获取客户信息出错！');
        }

      },
      submitForm(formName) {
        let that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let data = Object.assign({}, this.form);
            let old_data = Object.assign({}, this.old_form);
            if(JSON.stringify(data) === JSON.stringify(old_data)) {
              this.$message.warning('数据未修改，无需保存！');
              return false;
            }
            data.old_form = JSON.stringify(old_data);

            this.$myhttp.post('admin/Customer/saveFamilyDocument', data).then(backdata => {
              let res = backdata.data

              this.$message({
                message: res.msg,
                type: res.code == 200 ? 'success' : 'error'
              })

              this.$Loading.finish();
            });

          } else {
            return false;
          }
        });
      },
      submitMemberForm(formName) {
        let that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let data = Object.assign({}, this.memberForm);
            this.$myhttp.post('admin/Customer/saveFamilyMember', data).then(backdata => {
              let res = backdata.data

              this.$message({
                message: res.msg,
                type: res.code == 200 ? 'success' : 'error'
              })

              if(res.code == 200) {
                this.getMemberList()
                this.addVisable = false
              }

              this.$Loading.finish();
            });

          } else {
            return false;
          }
        });

      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      filePreview(file) {

        let url = Common.getBaseUrl() + 'storage/' + file.url
        let a = document.createElement('a')
        a.href = url
        a.target = '_blank'//在新窗口打开
        a.click();

      },
      uploadRemove(file, fileList) {
        this.setAttachmentData(fileList)
      },
      setAttachmentData(fileList) {
        this.form.attachment = fileList.map(item => {
          return {name: item.name, url: item.url ? item.url : item.response.data}
        })
      },
      uploadSuccess(response, file, fileList) {
        this.setAttachmentData(fileList)
      },
      editMember(data = {customer_id: this.id}) {
        this.addVisable = true
        this.memberForm = this.getMemberFormData(data)
      },
      getRelationText(val) {
        if(val == 0) return "户主本人"
        for(let k in this.relationList) {
          if(this.relationList[k].value == val) {
            return this.relationList[k].label
          }
        }
        return "-"
      },
      timeFormat(val) {
        return val == 0 ? '' : Common.timeFormat(val, false)
      },
      getIsOwnerText(val) {
        return val == 0 ? '否' : '是'
      },
      getIsOverText(val) {
        if(val) {
          let birthday = Common.timeFormat(val, false)
          return Common.getAge(birthday, false) >= 60 ? '是' : '否'
        }
      },
      deleteFamilyMember(id) {
        this.$confirm('此操作将删除此家庭成员, 是否继续?', '提示', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then(() => {
          this.$myhttp.post('admin/Customer/deleteFamilyMember?id='+id).then(backdata => {
            let res = backdata.data
            this.$message.success(res.msg);
            if(res.code == 200) {
              this.getMemberList()
            }
          })
        })
      },
      getJobText(val) {
        for(let k in this.jobList) {
          if(this.jobList[k].value == val) return this.jobList[k].label
        }
        return ''
      }
    }
  }
</script>

<style lang="scss" scoped="scoped">

  @import "./common.scss";

  .member-title {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: bold;
  }

  .el-date-editor.el-input {
    width: auto;
  }

  .add-member {
    margin-left: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/family-document-editor.vue